let country = '';
const locations = {
    'Germany': 'https://de.bruichladdich.com',
    'United Kingdom': 'https://uk.bruichladdich.com',
    'France': 'https://fr.bruichladdich.com',
    'United States': 'https://us.bruichladdich.com',
    "global": "https://www.bruichladdich.com"
};

const geolocation = document.querySelector('.geolocation');
const geolocation_heading = document.querySelector('.geolocation__text .geolocation__heading');
const geolocation_content = document.querySelector('.geolocation__text .geolocation__content');
const yes = document.querySelector('.js-geolocation-yes');
const no = document.querySelector('.js-geolocation-no');
const close = document.querySelector('.js-geolocation-close');

const hideGeolocation = () => {
    geolocation.classList.add('geolocation--hidden');
    localStorage.setItem('redirect', 'no');
};

const handleRedirection = (country) => {
  let location = locations[country];
  if (!location) {
      country = "global";
      location = locations[country];
  }
  window.location.href = location + window.location.pathname;
};

fetch('/browsing_context_suggestions.json')
    .then(res => res.json())
    .then(res => {
      const { detected_values } = res;
      const country = detected_values.country_name;
      const country_handle = detected_values.country.handle.toLowerCase();
      if (country !== 'United Kingdom' && localStorage.getItem('redirect') !== 'no') {
        const translations = {
          de: {
            heading: `Es sieht so aus, als ob Sie unsere Website von deutschlands besuchen.`,
            content: `Sie können zu unserer deutschlands Seite wechseln, um unsere Single Malts zu durchsuchen, aktuelle Veröffentlichungen online zu kaufen und in ausgewählte Länder und Orte weltweit zu liefern, die neuesten Nachrichten zu lesen und ein Konto zu erstellen.`,
            redirect_cta: `Ich möchte zur deutschlands Website wechseln`,
            stay_cta: `Bleiben Sie auf der UK-Website`
          },
          fr: {
            heading: `Il semblerait que vous visitiez notre site web depuis la France.`,
            content: `Nous vous encourageons à poursuivre votre exploration depuis notre site France pour une navigation optimale. Vous pourrez y retrouver tous nos single malts, vous procurer les nouveautés produits de la distillerie et bénéficier d'une livraison adaptée à votre localité, découvrir nos dernières actualités et même créer votre compte.`,
            redirect_cta: `Poursuivre via le site France`,
            stay_cta: `Rester sur le site UK`
          },
          us: {
            heading: `It looks like you are visiting our website from the United States.`,
            content: `You can switch to our US site to browse our single malts, buy current releases online for delivery to the United States, and explore the latest news.`,
            redirect_cta: `Take me to the US site`,
            stay_cta: `Stay on the UK site`
          },
          default: {
            heading: `It looks like you are visiting our website from outside the UK.`,
            content: `You can switch to our global site to browse our single malts, buy current releases online for delivery to select countries and locations globally, explore the latest news and create an account.`,
            redirect_cta: `Take me to the Rest of World site`,
            stay_cta: `Stay on the UK site`
          }
        };

        const translation = translations[country_handle] || translations.default;

        geolocation_heading.textContent = translation.heading;
        geolocation_content.textContent = translation.content;
        yes.textContent = translation.redirect_cta;
        no.textContent = translation.stay_cta;
        yes.addEventListener('click', () => handleRedirection(country));
        no.addEventListener('click', hideGeolocation);
        close.addEventListener('click', hideGeolocation);
        geolocation.classList.remove('geolocation--hidden');
      }
    }); 